import { render, staticRenderFns } from "./RiskChart.vue?vue&type=template&id=fa9b5cac&scoped=true"
import script from "./RiskChart.vue?vue&type=script&lang=js"
export * from "./RiskChart.vue?vue&type=script&lang=js"
import style0 from "./RiskChart.vue?vue&type=style&index=0&id=fa9b5cac&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b5cac",
  null
  
)

export default component.exports